import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { fontSize } = typographyStyles;
const neutral400 = ui.neutral[400];
const neutral100 = ui.neutral[100];
const white50 = ui.white[50];

export const editorBodyStyles: CSSObject = {
  '.tiptap.ProseMirror[contenteditable="true"]': {
    border: `1px solid ${neutral400}`,
    backgroundColor: white50,
    borderRadius: "4px",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    maxHeight: "400px",
    minHeight: "140px",
    overflowY: "auto",
    padding: "0 0.6em",

    h1: {
      ...fontSize.heading1,
    },

    h2: {
      ...fontSize.heading2,
    },

    h3: {
      ...fontSize.heading3,
    },

    ol: {
      li: {
        listStyle: "decimal",
      },
    },

    ul: {
      li: {
        listStyle: "disc",
      },
    },

    "li > p": {
      margin: 0,
    },

    blockquote: {
      borderLeft: `4px solid ${neutral100}`,
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: "24px",
      paddingRight: "24px",
      fontStyle: "italic",
    },
  },
};
